import type { SidePanel } from '../types';

export const TaxiparkSubjects: SidePanel.VueComponent = {
  component: defineAsyncComponent(() => import('./TaxiparkSubjectsPanel.vue')),
};
